import { formatDate } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { SessionContextService } from '../context/session-context.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private _sessionContext: SessionContextService,
              private _sessionService: SessionService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    if (this._sessionContext && this._sessionContext.sessionUser && !request.url.includes("RefreshToken")) {
      const d = new Date(formatDate(this._sessionContext.sessionUser.utcExpirationTime, 'yyyy-MM-dd HH:mm:ss', 'en-GB'));
      const d2 = new Date();

      if (d2 > d){
        if (localStorage.token) {
          const refreshToken = {
            authenticationToken:this._sessionContext.sessionUser.token,
            refreshToken: this._sessionContext.sessionUser.refreshToken.token
          }

          return this._sessionService.refreshToken(refreshToken).pipe(
            tap(resp => {
              this._sessionContext.sessionUser = resp;
              this._sessionContext.sessionToken = resp.token;
              this._sessionContext.userClaims = resp.lsClaimTypes;
              const payload = JSON.parse(window.atob(this._sessionContext.sessionToken.split('.')[1]));
              this._sessionContext.sessionUser.role = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

              localStorage.user = JSON.stringify(resp);
              localStorage.token = resp.token;
              localStorage.claims = resp.lsClaimTypes;
            }, (error) => {
              this._sessionService.logout();
              return next.handle(request);
          }),
            switchMap( resp => {
              const newRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${resp.token}`
                }
              });
              return next.handle(newRequest);
            })
          )
        } else {
          this._sessionService.logout();
          return next.handle(request);
        }
      } else {
        return this._sessionContext && this._sessionContext.sessionUser && this._sessionContext.sessionUser.token ?
        next.handle(request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + this._sessionContext.sessionUser.token) })) :
        next.handle(request);
      }
    } else {
      return next.handle(request);
    }


  }
}
